export interface IOrderTrackingEvent {
  orderId: string;
  orderNumber: string;
  expectedDeliveryTimeSlot: {
    start: string;
    end: string;
  };
  trackingUrl?: string;
  updatedAt: string;
  status: OrderTrackingEventStatus;
}

export enum OrderTrackingEventStatus {
  pending = 'pending',
  ready = 'ready',
  inDelivery = 'in_delivery',
  delivered = 'delivered',
  error = 'error',
  rescheduled = 'rescheduled',
}
